import React, { useEffect } from "react";
import { Card, Flex, Form, Input, Select, Tag, Typography } from "antd";
import "react-phone-number-input/style.css";
import PhoneInputWithCountrySelect from "react-phone-number-input";
import { css } from "@emotion/css";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerIdAction } from "../../../../../../../../store/action/admin/dimensionsEntityActions";
const { Text } = Typography;

export const GeneralDetailsCard = ({
  themeDefault,
  tradeLicenseList,
  form,
  isCreateMode = true,
}) => {
  const dispatch = useDispatch();
  const getCustomerIdList = useSelector((state) => state.getCustomerIdList);
  const getClientFormBuilderList = useSelector(
    (state) => state.getClientFormBuilderList
  );

  const customerIdFromCreate = getCustomerIdList?.info || null;
  const customerIdFromEdit =
    getClientFormBuilderList?.info?.customerDetails?.customerId || null;
  const customerId = isCreateMode ? customerIdFromCreate : customerIdFromEdit;

  useEffect(() => {
    if (isCreateMode) {
      dispatch(getCustomerIdAction());
    }
  }, [dispatch, isCreateMode]);

  useEffect(() => {
    if (customerId && form) {
      form.setFieldsValue({ customerId });
    }
  }, [customerId, form]);

  return (
    <Card
      bordered
      title={
        <div
          style={{
            borderBottom: themeDefault?.info?.newConfig?.cardborder,
            paddingBottom: 8,
          }}
        >
          General Details
        </div>
      }
    >
      <Flex gap={16} wrap="wrap">
        <Form.Item
          name="customerId"
          label="Customer ID"
          style={{ flex: 1, minWidth: 220, marginBottom: 8 }}
          rules={[
            {
              required: true,
              message: "Customer ID is required",
            },
          ]}
        >
          <Input disabled placeholder="Enter Customer ID" />
        </Form.Item>

        <Form.Item
          name="customerName"
          label="Customer Name"
          style={{ flex: 1, minWidth: 220, marginBottom: 8 }}
          rules={[
            {
              required: true,
              message: "Customer Name is required",
            },
          ]}
        >
          <Input placeholder="Enter Customer Name" />
        </Form.Item>
      </Flex>

      <Flex gap={16} wrap="wrap">
        <Form.Item
          name="customerWebsite"
          label="Customer Website"
          style={{ flex: 1, minWidth: 220, marginBottom: 8 }}
        >
          <Input placeholder="Enter Customer website" />
        </Form.Item>

        <Form.Item
          name="customerEmail"
          label="Customer Email"
          style={{ flex: 1, minWidth: 220, marginBottom: 8 }}
          rules={[
            {
              type: "email",
              message: "Please enter a valid email address",
            },
          ]}
        >
          <Input placeholder="Enter Customer email" />
        </Form.Item>
      </Flex>

      <Flex gap={16} wrap="wrap">
        <Form.Item
          name="customerPhone"
          label="Customer Phone"
          style={{ flex: 1, minWidth: 220, marginBottom: 8 }}
          className={css`
            .PhoneInputInput {
              padding-left: 12px;
            }
          `}
        >
          <PhoneInputWithCountrySelect
            placeholder="Enter phone number"
            international
            defaultCountry="AE"
          />
        </Form.Item>

        <Form.Item
          name="tradeLicenseId"
          label="Trade License"
          style={{ flex: 1, minWidth: 220, marginBottom: 8 }}
        >
          <Input placeholder="Enter Trade License" />
        </Form.Item>
        {/* #TODO: replace input in trade license with select after discussion with team */}
        {/* <Select
            placeholder="Select Trade License"
            showSearch
            allowClear
            filterOption={(input, option) => {
              const searchText = input.toLowerCase();
              const licenseName = option?.label || "";
              const expiryDate = option?.expiryDate || "";
              return (
                licenseName.toLowerCase().includes(searchText) ||
                expiryDate.toLowerCase().includes(searchText)
              );
            }}
            optionLabelProp="label"
            notFoundContent={
              !tradeLicenseList || tradeLicenseList.length === 0
                ? "No trade licenses available"
                : "No results found"
            }
          >
            {tradeLicenseList && tradeLicenseList.length > 0
              ? tradeLicenseList.map((license) => {
                  const getStatusColor = (status) => {
                    switch (status?.toLowerCase()) {
                      case "active":
                        return "green";
                      case "expired":
                        return "red";
                      case "pending":
                        return "orange";
                      default:
                        return "default";
                    }
                  };

                  return (
                    <Select.Option
                      key={license._id}
                      value={license._id}
                      label={license.tradeLicenseName}
                      expiryDate={license.expiryDate}
                    >
                      <Flex
                        justify="space-between"
                        align="flex-start"
                        style={{ width: "100%" }}
                      >
                        <Flex vertical gap={4} style={{ flex: 1 }}>
                          <Text strong>{license.tradeLicenseName}</Text>
                          <Text type="secondary" style={{ fontSize: 12 }}>
                            Expiry: {license.expiryDate}
                          </Text>
                        </Flex>
                        <Tag
                          color={getStatusColor(license.licenseStatus)}
                          style={{ marginLeft: 8 }}
                        >
                          {license.licenseStatus}
                        </Tag>
                      </Flex>
                    </Select.Option>
                  );
                })
              : null}
          </Select> */}
      </Flex>
    </Card>
  );
};
